import Vapi from 'vuex-rest-api';

const fetcherAdminPost = new Vapi({
  state: {
    fetcherAdminPost: {
      pid: '',
    },
  },
})
  .get({
    action: 'getFetcherAdminPost',
    property: 'fetcherAdminPost',
    path: ({ pid }) => `/api/fetcher/admin/posts/${pid}`,
  })
  .getStore();

export default fetcherAdminPost;
